import React from 'react';
import { TeamMembersData } from 'Data';

function Team() {
	const currentPage = 1;
	const postsPerPage = 3;

	// Get current posts
	const indexOfLastPost = currentPage * postsPerPage;
	const indexOfFirstPost = indexOfLastPost - postsPerPage;
	const currentPosts = TeamMembersData.slice(indexOfFirstPost, indexOfLastPost);

	return (
		<>
			{currentPosts.map((member, id) => (
				<div key={id} className='flex flex-col items-center'>
					<div className='w-60 h-60 rounded-full overflow-hidden border-4 border-secondary border-solid'>
						<img
							src={member.image}
							alt={member.name}
							className='w-full h-full object-cover'
						/>
					</div>
					<div className='text-lg pt-6 text-center'>
						<p className='font-bold'>{member.name}</p>
						<p className='font-normal'>{member.title}</p>
					</div>
				</div>
			))}
		</>
	);
}

export default Team;
